import axios from "axios";

// The REST endpoints (records, final reports, tarjetones, documents, uploads...)
// require the signed-in user's token. Rather than remember to add the header in
// every hook, attach it here to every axios call that goes to our own API — and
// only ours, so the token is never sent to another site.
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  const toOurApi = typeof config.url === "string" && config.url.startsWith(API_URL);
  if (token && toOurApi && !(config.headers && config.headers.Authorization)) {
    config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
  }
  return config;
});
